// extracted by mini-css-extract-plugin
module.exports = {"SectionA3":"SectionGraphicText_SectionA3__x_0qp"};